import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col} from 'react-bootstrap'
import cx from 'classnames'
import {infoStatus} from '../../core/redux/status'
import {linkFinder} from '../../core/links'
import phonez from '../../core/phonez'
import {percentage} from '../../core/mathz'
import DashboardPanel from '../../core/components/DashboardPanel'
import DashboardPanelAdd from '../../core/components/DashboardPanelAdd'
import Icon from '../../core/components/Icon'
import ClosingRateDashboardPanel from '../../ticket/components/ClosingRateDashboardPanel'
import ClosingEventDashboardPanel from '../../ticket/components/ClosingEventDashboardPanel'
import i18n from '../i18n'
import InterventionDelayDashboardPanel from './InterventionDelayDashboardPanel'
import InterventionNumberDashboardPanel from './InterventionNumberDashboardPanel'
import MissionAcceptedDelayDashboardPanel from './MissionAcceptedDelayDashboardPanel'
import RepairDelayDashboardPanel from './RepairDelayDashboardPanel'
import CallBeforeMissionAcceptedDashboardPanel from './CallBeforeMissionAcceptedDashboardPanel'
import style from './ContactDashboard.less'

class ContactDashboard extends Component {
    static propTypes = {
    }

    _navigate(event, provider) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push('/providers/' + provider.uid))
    }

    render() {
        const {dispatch, contact, contactStats, _appLinks} = this.props

        const repairTimelimitStat = contactStats.complianceWithCommitments.repairTimelimit
        const interventionTimelimitStat = contactStats.complianceWithCommitments.interventionTimelimit

        const repairTimelimitRate = percentage({
            source: Object.keys(repairTimelimitStat),
            identify: (k) => repairTimelimitStat[k],
            match: (k) => k == 'ticketCompliant'
        })
        
        const interventionTimelimitRate = percentage({
            source: Object.keys(interventionTimelimitStat),
            identify: (k) => interventionTimelimitStat[k],
            match: (k) => k == 'ticketCompliant'
        })

        const complianceStatus = (percentage) => {
            if (percentage >= 85) return 'success'
            if (percentage >= 65) return 'warning'
            if (!isNaN(percentage)) return 'danger'
        }

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <div>
                <Row>
                    <Col sm={6} md={4}>
                        <DashboardPanel light
                            header={panelHeader(i18n.description)}>
                            <ul className={style.data}>
                                {contact.phones.length > 0 && (
                                    <li>
                                        <label>> {i18n.phone} :</label>
                                        {contact.phones.map((phone, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {phonez(phone).format()}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {contact.emails.length > 0 && (
                                    <li>
                                        <label>> {i18n.email} :</label>
                                        {contact.emails.map((email, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {email}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {contact.fax.length > 0 && (
                                    <li>
                                        <label>> {i18n.fax} :</label>
                                        {contact.fax.map((fax, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {phonez(fax).format()}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {contact.providerCompany && (
                                    <li>
                                        <label>
                                            <Icon icon='plus' size='xs' />
                                            <span>{i18n.providerz} :</span>
                                        </label>
                                        <a
                                            href=''
                                            onClick={(e) => this._navigate(e, contact.providerCompany)}>
                                            <span> {contact.providerCompany.name}</span>
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </DashboardPanel>
                        {_appLinks.find(linkFinder('tickets')) && (
                            <ClosingRateDashboardPanel light />
                        )}
                    </Col>
                    <Col sm={6} md={4}>
                        <DashboardPanelAdd 
                            onClick={() => dispatch(infoStatus(i18n.featureNotImplemented))} />
                    </Col>
                    <Col sm={6} md={4}>
                        {_appLinks.find(linkFinder('tickets')) && (
                            <ClosingEventDashboardPanel light />
                        )}
                    </Col>
                    <Col sm={12} md={8}>
                        <InterventionDelayDashboardPanel light />
                    </Col>
                    <Col sm={12} md={6}>
                        <MissionAcceptedDelayDashboardPanel light />
                    </Col>
                    <Col sm={12} md={6}>
                        <RepairDelayDashboardPanel light />
                    </Col>
                    <Col sm={12} md={6}>
                        <CallBeforeMissionAcceptedDashboardPanel light />
                    </Col>
                    <Col sm={12} md={6}>
                        <InterventionNumberDashboardPanel light />
                    </Col>
                    <Col sm={12} md={6}>
                        <DashboardPanel light
                            header={panelHeader(i18n.repairTimelimitRate)}>
                            <div className={style.repairTimelimitRate}>
                                {!isNaN(repairTimelimitRate) && (
                                    <div>
                                        <span className={cx(style.rate, style[complianceStatus(interventionTimelimitRate)])}>{repairTimelimitRate} %</span>
                                        <div className={style.stats}>
                                            <div className={style.count}>
                                                <span>{repairTimelimitStat.ticketCompliant}</span>
                                                <small>{i18n.compliantTickets}</small>
                                            </div>
                                            <div className={style.count}>
                                                <span>{repairTimelimitStat.ticketNonCompliant}</span>
                                                <small>{i18n.notCompliantTickets}</small>
                                            </div>
                                            <div className={style.count}>
                                                <span>{repairTimelimitStat.ticketCompliant + repairTimelimitStat.ticketNonCompliant}</span>
                                                <small>{i18n.qualifiedTickets}</small>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </DashboardPanel>
                    </Col>
                    <Col sm={12} md={6}>
                        <DashboardPanel light
                            header={panelHeader(i18n.interventionTimelimitRate)}>
                            <div className={style.interventionTimelimitRate}>
                                {!isNaN(interventionTimelimitRate) && (
                                    <div>
                                        <span className={cx(style.rate, style[complianceStatus(interventionTimelimitRate)])}>{interventionTimelimitRate} %</span>
                                        <div className={style.stats}>
                                            <div className={style.count}>
                                                <span>{interventionTimelimitStat.ticketCompliant}</span>
                                                <small>{i18n.compliantTickets}</small>
                                            </div>
                                            <div className={style.count}>
                                                <span>{interventionTimelimitStat.ticketNonCompliant}</span>
                                                <small>{i18n.notCompliantTickets}</small>
                                            </div>
                                            <div className={style.count}>
                                                <span>{interventionTimelimitStat.ticketCompliant + interventionTimelimitStat.ticketNonCompliant}</span>
                                                <small>{i18n.qualifiedTickets}</small>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </DashboardPanel>
                    </Col>
                </Row>
            </div>
        )
    }
}

ContactDashboard = connect((state) => ({
    contact: state.provider.contact.contact,
    contactStats: state.provider.contact.contactStats,
    _appLinks: state.app._links
}))(ContactDashboard)

export default ContactDashboard


// WEBPACK FOOTER //
// ./lib/provider/components/ContactDashboard.js